import React from 'react';
import './GenerationLanguageToggle.css';

export default function GenerationLanguageToggle({ value, onChange, disabled }) {
    return <fieldset className="generation-language" disabled={disabled}>
        <legend>Generate in</legend>
        <div className="generation-language__options">
            {['English', 'Afrikaans'].map((language) => <label key={language}>
                <input type="radio" name="outputLanguage" value={language} checked={value === language} onChange={() => onChange(language)} />
                <span>{language}</span>
            </label>)}
        </div>
    </fieldset>;
}
